var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubtractCircleFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99999 18.3334C14.6024 18.3334 18.3333 14.6025 18.3333 10.0001C18.3333 5.39771 14.6024 1.66675 9.99999 1.66675C5.39761 1.66675 1.66666 5.39771 1.66666 10.0001C1.66666 14.6025 5.39761 18.3334 9.99999 18.3334ZM5.83332 10.8334H14.1667V9.16675H5.83332V10.8334Z",
    fill: "#C8C8C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtractCircleFill);
export default __webpack_public_path__ + "static/media/subtract_circle_fill.61a24800b125ec8f98ebcb8dbd4cedb8.svg";
export { ForwardRef as ReactComponent };